// 定制裁剪:本部署全部用户使用 zh_CN,只打包 en(兜底)+ zh_CN。
// 移除其余 39 种语言可让 dashboard 首屏 JS 从 ~12MB 降到 ~0.6MB,
// 解决所有页面首次加载转圈很久的问题。如需恢复某语言,加回 import + 导出即可。
import en from './locale/en';
import zh_CN from './locale/zh_CN';

export default {
  en,
  zh_CN,
};
